import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import CitationCJ from './pages/CitationCJ';
import { Toaster } from './components/ui/sonner';
import { initFacebookPixel } from './utils/facebookPixel';
import { initGoogleAnalytics } from './utils/googleAnalytics';
import { Phone, Mail, MapPin, Wrench } from 'lucide-react';

// Set to false to show the live site again
const MAINTENANCE_MODE = true;

function MaintenancePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 flex items-center justify-center px-6">
      <div className="max-w-2xl w-full text-center">
        <div className="mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_elated-noether/artifacts/3ed29j83_66226fedd4129f1c48c298c2_james-spearman.svg"
            alt="Spearman Aircraft Logo"
            className="h-14 w-auto mx-auto mb-6 brightness-0 invert"
          />
        </div>
        <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-10 border border-white/10 shadow-2xl">
          <div className="w-20 h-20 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Wrench className="w-10 h-10 text-blue-400" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Website Under Maintenance
          </h1>
          <p className="text-lg text-slate-300 mb-8 leading-relaxed">
            We're making improvements to serve you better. Our site will be back online shortly. In the meantime, please contact us directly for quotes and inquiries.
          </p>
          <div className="grid sm:grid-cols-2 gap-4 mb-8">
            <a
              href="tel:8653661449"
              className="flex items-center justify-center gap-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl px-6 py-4 transition-all duration-300 font-semibold"
            >
              <Phone className="w-5 h-5" />
              (865) 366-1449
            </a>
            <a
              href="mailto:info@spearmanaircraft.com"
              className="flex items-center justify-center gap-3 bg-white/10 hover:bg-white/20 text-white rounded-xl px-6 py-4 transition-all duration-300 font-semibold border border-white/20"
            >
              <Mail className="w-5 h-5" />
              Email Us
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 text-slate-400 text-sm">
            <MapPin className="w-4 h-4" />
            <span>1235 Airport Road, Sevierville, TN 37862</span>
          </div>
        </div>
        <p className="text-slate-500 text-sm mt-8">
          &copy; 2025 Spearman Aircraft. All rights reserved.
        </p>
      </div>
    </div>
  );
}

function App() {
  useEffect(() => {
    if (!MAINTENANCE_MODE) {
      initFacebookPixel();
      initGoogleAnalytics();
    }
  }, []);

  if (MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/citation-cj1-cj2-upgrade-garmin" element={<CitationCJ />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;